import type {
  KolPayout,
  KolPayoutMethod,
  KolReferralCode,
  KolStats,
  KolStatus,
} from "@/types/api";
import { request } from "./transport";

export interface CreatorSelf {
  readonly id: string;
  readonly name: string;
  readonly handle: string | null;
  readonly platform: string;
  readonly follower_count: number;
  readonly commission_bps: number;
  readonly status: KolStatus;
  readonly profile_url: string | null;
  readonly payout_method: KolPayoutMethod;
  readonly payout_contact: string | null;
  readonly email: string | null;
  readonly slug: string | null;
  readonly user_id: number | null;
  readonly created_at: string;
  readonly updated_at: string;
  readonly stats: KolStats;
}

export interface KolDashboard {
  readonly kol: CreatorSelf;
  readonly codes: readonly KolReferralCode[];
  readonly payouts: readonly KolPayout[];
}

export const kolDashboard = {
  getKolDashboard: () => request<KolDashboard>("/kol/dashboard"),
};
